var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collective-detail',{attrs:{"breadcrumb-route":"projects","item-type":"projects","item-type-single":"project","has-likes":""}})}
var staticRenderFns = []

export { render, staticRenderFns }